import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';
import { action } from 'satcheljs';

/**
 * Action to update the automatic replies view state
 */
const updateAutomaticRepliesViewState = action(
    'updateAutomaticRepliesViewState',
    (mailboxAutoReplyConfiguration: MailboxAutoReplyConfigurationOptions) => ({
        mailboxAutoReplyConfiguration,
    })
);

export default updateAutomaticRepliesViewState;
